import { isMobileDevice } from '../../utils'
import { IOnboardingData } from '../../services/apis/user/useUserRequest'

const SKIP_TO_ALL_SET_KEY = 'ld_onboarding_skip_to_all_set'

export const markSkippedToAllSet = () => {
    try {
        localStorage.setItem(SKIP_TO_ALL_SET_KEY, '1')
    } catch {
        /* ignore */
    }
}

export const hasSkippedToAllSet = (): boolean => {
    try {
        return localStorage.getItem(SKIP_TO_ALL_SET_KEY) === '1'
    } catch {
        return false
    }
}

export const clearSkippedToAllSet = () => {
    try {
        localStorage.removeItem(SKIP_TO_ALL_SET_KEY)
    } catch {
        /* ignore */
    }
}

/** Mobile signup — same backend state as "Continue without app". */
export const skipExtensionForSurveyOnboarding = async (
    saveOnboardingData: (payload: IOnboardingData) => Promise<void>,
) => {
    if (!isMobileDevice()) return
    await saveOnboardingData({ startedExtensionInstallation: false })
}
